import { Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import BarItemTooltip from "../BarItemTooltip";
import { formatCurrency } from "../formatters";
import { BrandMtdRow } from "./brandsApiMapping";

interface BrandsIncomeChartProps {
  rows: BrandMtdRow[];
}

export default function BrandsIncomeChart({ rows }: BrandsIncomeChartProps) {
  return (
    <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Total income by brand (MTD)
      </Typography>
      <BarChart
        height={270}
        xAxis={[{ scaleType: "band", data: rows.map((row) => row.brand.replace(" Optifund", "")) }]}
        series={[
          {
            data: rows.map((row) => row.income),
            color: "#8E24AA",
            valueFormatter: (value) => (value === null ? "" : formatCurrency(value)),
          },
        ]}
        tooltip={{ trigger: "none" }}
      >
        <BarItemTooltip />
      </BarChart>
    </Paper>
  );
}
